<template>
  <b-row>
    <b-col>
      <b-card>
        <div class="bcard-body">
          <div v-if="isLoadingAgreements">
            <Loader></Loader>
          </div>
          <div v-else-if="getAgreementsForMassEdit.length < 1 && !isLoadingAgreements">
            {{ $t('views.agreements.list.noSelectedAgreements') }}
          </div>
          <table class="table table-sm table-striped table-hover text-center" style="border-collapse: separate; border-spacing: 0 20px;" v-else>
            <thead>
            <tr>
              <th style="width: 8%">{{ $t('views.agreements.list.massEditModified') }}</th>
              <th style="width: 16%">{{ $t('views.agreements.list.dateFrom') }}</th>
              <th style="width: 16%">{{ $t('views.agreements.form.dateTo') }}</th>
              <th style="width: 16%">{{ $t('views.agreements.list.agreementNumber') }}</th>
              <th style="width: 16%">{{ $t('views.agreements.list.paymentPlan') }}</th>
              <th style="width: 8%">{{ $t('views.agreements.list.status') }}</th>
              <th style="width: 16%">{{ $t('views.agreements.list.userData') }}</th>
            </tr>
            </thead>
            <tbody v-for="(item, index) in getAgreementsForMassEdit" :key="item['@id']">
              <tr v-if="item.isLoading">
                <td colspan="7"><Loader></Loader></td>
              </tr>
              <tr v-else>
                <td colspan="7">
                  <b-row @click="expand(index)">
                    <b-col cols="1">
                      <span v-if="isRowModified(item)">{{ $t('global.yes') }}</span>
                      <span v-else>{{ $t('global.no') }}</span>
                    </b-col>
                    <b-col cols="2">
                      {{ item.dateFrom ? $moment(item.dateFrom).format('YYYY-MM-DD') : ' - ' }}
                    </b-col>
                    <b-col cols="2">
                      {{ item.dateTo ? $moment(item.dateTo).format('YYYY-MM-DD') : ' - ' }}
                    </b-col>
                    <b-col cols="2">
                      {{ item.number || $t('views.agreements.list.noNumber') }}
                    </b-col>
                    <b-col cols="2">
                      {{ getPaymentsModelTitle(item.idPaymentsModel) }}
                    </b-col>
                    <b-col cols="1">
                      <div>
                        {{ $t(getAgreementStatuses[item.status]) }}
                      </div>
                      <b-badge v-if="item.decisionUser == 0"> {{
                          $t('views.agreements.list.decisionUser.offer')
                        }}
                      </b-badge>
                      <b-badge variant="primary" v-else-if="item.status == 1">
                        {{ $t('views.agreements.list.decisionUser.waiting') }}
                      </b-badge>
                      <b-badge variant="warning" v-else-if="item.decisionUser == 2">
                        {{ $t('views.agreements.list.decisionUser.rejected') }}
                      </b-badge>
                      <b-badge variant="success" v-else-if="item.decisionUser == 3 && item.status == 3">
                        {{
                          $t('views.agreements.list.decisionUser.accepted') + ' - ' + $moment(item.signedDate).format('YYYY-MM-DD HH:mm')
                        }}
                      </b-badge>
                      <b-badge variant="success" v-else-if="item.decisionUser == 5 && item.status == 3">
                        {{
                          $t('views.agreements.list.decisionUser.signed') + ' - ' + $moment(item.signedDate).format('YYYY-MM-DD HH:mm')
                        }}
                      </b-badge>
                    </b-col>
                    <b-col cols="2">
                      {{ item.idClientName }}
                    </b-col>
                  </b-row>
                  <b-collapse :id="'agreements_collapse_'+index" v-model="item.expanded">
                    <b-row>
                      <b-col>
                        <AgreementItems
                          :items-from-agreement="items"
                          :data="item"
                          :violations="[]"
                          :is-invalid="() => {return false}">
                        </AgreementItems>
                        <AgreementAdditionalItems
                          v-if="item.type === 1"
                          :items-from-agreement="items"
                          :data="item"
                          :violations="[]"
                          :is-invalid="() => {return false}">
                        </AgreementAdditionalItems>
                        <hr>
                        <AgreementPromotions
                          v-show="false"
                          :promotions-from-agreement="promotions"
                          :data="item"
                          :violations="[]">
                        </AgreementPromotions>
                      </b-col>
                    </b-row>
                    <b-row v-if="isRowModified(item)">
                      <b-col>
                        <b-button class="btn float-right btn-info" @click="updateItem(item)">{{ $t('buttons.submit') }}</b-button>
                        <b-button class="btn float-right btn-danger mr-1" @click="revertItem(item)">{{ $t('buttons.revertItem') }}</b-button>
                      </b-col>
                    </b-row>
                  </b-collapse>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import AgreementItems from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/Form/AgreementItems'
import AgreementAdditionalItems from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/Form/AgreementAdditionalItems'
import addParamsToQuery from '@/utils/addParamsToQuery'
import Loader from '@/components/Dashboard/Layout/Loader'
import ApiService from '@/utils/ApiService'
import AgreementPromotions from '@/components/Dashboard/Views/AgreementsBundle/agreements/components/Form/AgreementPromotions'

export default {
  name: 'AgreementsMassEdit',
  components: {
    AgreementPromotions,
    Loader,
    AgreementItems,
    AgreementAdditionalItems
  },
  props: {
    agreementsIds: {
      type: Array,
      default: () => {
        return []
      }
    }
  },
  data () {
    return {
      selectedItems: [],
      selectedItem: null
    }
  },
  created () {
    this.getItems()
    this.fetchPromotions()
    this.fetchAgreementsForMassEdit(this.getBaseParams())
    if (!(this.getPaymentsModelOptions.length > 0)) {
      this.fetchPaymentsModelOptions()
    }
  },
  computed: {
    ...mapGetters({
      view: 'agreements/list/getAgreementsView',
      getAgreementsForMassEdit: 'agreements/list/getAgreementsForMassEdit',
      getAgreementStatuses: 'agreements/list/getAgreementStatuses',
      getPaymentsModelOptions: 'agreements/list/getPaymentsModelOptions',
      getAgreementTypes: 'agreements/list/getAgreementTypes',
      isLoadingAgreements: 'agreements/list/getIsLoadingAgreementsMassEdit',
      isLoadingPaymentsModelOptions: 'agreements/list/getIsLoadingPaymentsModelOptions',
      items: 'exsbitem/list/items',
      promotions: 'agreements/list/getPromotions'
    })
  },
  methods: {
    editAgreement (id) {
      this.$router.push({ name: 'EXABAgreementsUpdate', params: { id: id } })
    },
    getBaseParams () {
      return { idAgreements: this.agreementsIds }
    },
    getPaymentsModelTitle (id) {
      if (this.getPaymentsModelOptions.length > 0) {
        // eslint-disable-next-line eqeqeq
        return this.getPaymentsModelOptions.find(model => model.id == id).title
      }
      return ''
    },
    isRowModified (item) {
      return (JSON.stringify(item.agreementItems) !== item.originalAgreementItems) ||
             (JSON.stringify(item.agreementAdditionalItems) !== item.originalAgreementAdditionalItems) ||
             (JSON.stringify(item.agreementPromotions) !== item.originalAgreementPromotions)
    },
    revertItem (item) {
      item.agreementItems = JSON.parse(item.originalAgreementItems)
      item.agreementAdditionalItems = JSON.parse(item.originalAgreementAdditionalItems)
      item.agreementPromotions = JSON.parse(item.originalAgreementPromotions)
    },
    async updateItem (item) {
      item.isLoading = true
      let agreement = {
        '@id': item['@id'],
        agreementItems: item.agreementItems.map(entry => {
          return {
            '@id': entry['@id'],
            item: entry.item,
            dateFrom: entry.dateFrom,
            dateTo: entry.dateTo,
            alwaysSettleInFull: entry.alwaysSettleInFull,
            isCyclic: entry.isCyclic,
            promotion: entry.promotion,
            agreement: item['@id']
          }
        }),
        agreementPromotions: item.agreementPromotions.map(entry => {
          return { '@id': entry['@id'], promotion: entry.promotion, agreement: item['@id'] }
        })
      }
      const response = await new ApiService(agreement['@id']).put(agreement)
      if (response.status === 200) {
        let responseData = await response.json()
        item.isLoading = false
        item.agreementItems = responseData.agreementItems.map(entry => {
          return {
            '@id': entry['@id'],
            item: entry.item['@id'],
            priceUserData: entry.priceUserData,
            dateFrom: entry.dateFrom,
            dateTo: entry.dateTo,
            isCyclic: entry.isCyclic,
            canBeCyclic: !!entry.item.isCyclic,
            hasPromotion: !!entry.promotion,
            promotion: entry.promotion ? entry.promotion['@id'] : null,
            alwaysSettleInFull: entry.alwaysSettleInFull
          }
        })
        item.originalAgreementItems = JSON.stringify(item.agreementItems)
        item.agreementAdditionalItems = responseData.agreementAdditionalItems.map(entry => {
          return {
            '@id': entry['@id'],
            item: entry.item['@id'],
            priceUserData: entry.priceUserData,
            dateFrom: entry.dateFrom,
            dateTo: entry.dateTo,
            isCyclic: entry.isCyclic,
            canBeCyclic: !!entry.item.isCyclic,
            hasPromotion: !!entry.promotion,
            promotion: entry.promotion ? entry.promotion['@id'] : null,
            additionalDocumentTemplate: entry.additionalDocumentTemplate
          }
        })
        item.originalAgreementAdditionalItems = JSON.stringify(item.agreementAdditionalItems)
        item.agreementPromotions = responseData.agreementPromotions.map(entry => {
          return { '@id': entry['@id'], promotion: entry.promotion['@id'] }
        })
        item.originalAgreementPromotions = JSON.stringify(item.agreementPromotions)
      }
    },
    ...mapMutations({
      setAgreementId: 'agreements/previewModal/setAgreementId',
      setRetrieved: 'agreements/update/setRetrieved'
    }),
    ...mapActions({
      fetchAgreementsForMassEdit: 'agreements/list/fetchAgreementsForMassEdit',
      fetchPaymentsModelOptions: 'agreements/list/fetchPaymentsModelOptions',
      fetchItems: 'exsbitem/list/getItems',
      fetchPromotions: 'agreements/list/fetchPromotions'
    }),
    getItems () {
      let link = addParamsToQuery('e_x_s_b_items', {
        pagination: false
      })
      this.fetchItems(link)
    },
    expand (expandIndex) {
      this.getAgreementsForMassEdit.forEach((consent, index) => {
        if (index !== expandIndex) {
          consent.expanded = false
        }
      })
      this.getAgreementsForMassEdit[expandIndex].expanded = !this.getAgreementsForMassEdit[expandIndex].expanded
      this.$forceUpdate()
    }
  }
}
</script>
